// extracted by mini-css-extract-plugin
module.exports = {"kensaOrder_Title":"OrderConfirm_kensaOrder_Title__nhnlO","kensaOrder_Confirm":"OrderConfirm_kensaOrder_Confirm__2syR2"};